/* ActualsMonthGrid.jsx -- one "(actuals)" month grid of the Deferred Revenue page (AE and Company Quota: Total ACV / Monthly GAAP
 * Revenue / Historical ARR; implementation: Total Implementation Revenue / Monthly GAAP Revenue). 2026-10-26: lifted VERBATIM from the
 * page's three inline copies (the same markup, the same typing rule) so the paste of a row copied from Excel has one home
 * (utils/pasteRow.js). The only additions: the paste hint, the paste handler and its message. Record: diffs/dr-paste-build.txt.
 *
 * THE TYPING RULE (unchanged): on blur the text loses its commas and is read with parseFloat; anything unreadable or blank stores 0.
 * A pasted row goes through the same rule: each value is stored as typed, a blank cell stores 0. Plain ASCII (CLAUDE.md 12.5 rule 55). */
import React, { useState } from 'react';
import { formatMonthLabel } from '../engines/dateUtils';
import { handleRowPaste, PASTE_ERROR_STYLE } from '../utils/pasteRow';
import PasteHint from '../utils/PasteHint';   // the tip + its "i" (one owner)

export default function ActualsMonthGrid({ title, help, values, onChange, months, keyBase, inputStyle }) {
  const [pasteError, setPasteError] = useState(null);
  const obj = values || {};
  const years = [...new Set(months.map(m => +(m || '').split('-')[0]))];
  return <div style={{ marginBottom: 10 }}>
    <div style={{ fontSize: 10, fontWeight: 600, color: '#4B5563', marginBottom: 2 }}>{title}</div>
    <div style={{ fontSize: 9, color: '#8B8FA3', marginBottom: 6 }}>{help}</div>
    <PasteHint />
    {years.map(yr => (
      <div key={yr} style={{ marginBottom: 6 }}>
        <div style={{ fontSize: 9, fontWeight: 600, color: '#6B7280', marginBottom: 3 }}>{yr}</div>
        <div style={{ display: 'flex', gap: 4 }}>
          {months.filter(m => +(m || '').split('-')[0] === yr).map(m => (
            <div key={m} style={{ flex: 1, minWidth: 0, maxWidth: 80 }}>
              <div style={{ fontSize: 8, color: '#8B8FA3', textAlign: 'center', marginBottom: 2 }}>{formatMonthLabel(m, 'short')}</div>
              <input type="text" defaultValue={(obj[m] || 0) ? (obj[m] || 0).toLocaleString('en-US') : ''} key={keyBase + '-' + m + '-' + (obj[m] || 0)}
                onFocus={e => { const v = obj[m] || 0; e.target.value = v ? String(v) : ''; e.target.select(); }}
                onBlur={e => { const v = parseFloat(e.target.value.replace(/,/g, '')) || 0; onChange(p => ({ ...p, [m]: v })); e.target.value = v ? v.toLocaleString('en-US') : ''; }}
                onPaste={e => handleRowPaste(e, { months, month: m, onError: setPasteError,
                  apply: cells => onChange(p => { const n = { ...p }; for (const [mo, v] of cells) n[mo] = v === null ? 0 : v; return n; }) })}
                placeholder="0" style={{ ...inputStyle, width: '100%', padding: '3px 4px', fontSize: 9 }} />
            </div>
          ))}
        </div>
      </div>
    ))}
    {pasteError && <div data-paste-error="" style={PASTE_ERROR_STYLE}>{pasteError}</div>}
  </div>;
}
